import { render, staticRenderFns } from "./regChart.vue?vue&type=template&id=05ac53e0&"
import script from "./regChart.vue?vue&type=script&lang=js&"
export * from "./regChart.vue?vue&type=script&lang=js&"
import style0 from "./regChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "regChart.vue"
export default component.exports